import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import { getUserRoleForBackend } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import { GetPendingOrdersRequest, GetPendingOrdersSuccessResponse } from './getPendingOrders.types'

export const getPendingOrdersApi = async (
  request: GetPendingOrdersRequest
): Promise<GetPendingOrdersSuccessResponse> => {
  const params: Record<string, string | number> = {}

  if (request.status) params.status = request.status
  if (request.page !== undefined) params.page = request.page
  if (request.limit !== undefined) params.limit = request.limit

  const response = await configureRequest({
    url: 'logistics-partner/orders/pending',
    method: 'GET',
    params,
    headers: {
      'X-User-Role': getUserRoleForBackend()
    }
  })

  return response as GetPendingOrdersSuccessResponse
}
